import { withLocale } from '@/util/categoryRoute'

// 登录相关
const loginRoutes = [
  {
    path: withLocale('/loginOther'),
    component: () => import('@/layout/default.vue'),
    children: [
      {
        path: withLocale('/register'),
        name: 'REGISTER',
        component: () => import('@/views/customerService/register/index.vue'),
        meta: {
          cnName: '注册',
          enName: 'Register'
        }
      }
    ]
  },
  {
    path: withLocale('/login'),
    name: 'LOGIN',
    component: () => import('@/views/login/index.vue'),
    meta: {
      cnName: '登录',
      enName: 'Login'
    }
  },
  {
    path: withLocale('/otherLogin'),
    name: 'otherLogin',
    component: () => import('@/views/login/component/other-login.vue'),
    meta: {
      cnName: '其他登录',
      enName: 'Login'
    }
  },
  {
    path: withLocale('/PrivacyPolicy'),
    name: 'PrivacyPolicy',
    component: () => import('@/views/login/privacyPolicy/index.vue'),
    meta: {
      cnName: '隐私政策',
      enName: 'Privacy Policy'
    }
  },
  {
    path: withLocale('/forgotPassword'),
    name: 'forgotPassword',
    component: () => import('@/views/login/forgot-password/index.vue'),
    meta: {
      cnName: '忘记密码',
      enName: 'Reset Password'
    }
  },
  {
    path: withLocale('/register2'),
    name: 'register2',
    component: () => import('@/views/login/register/index.vue'),
    meta: {
      cnName: '注册',
      enName: 'Register'
    }
  },
  {
    path: withLocale('/resetPassword'),
    name: 'resetPassword',
    component: () => import('@/views/login/reset-password/index.vue'),
    meta: {
      cnName: '已登录重置密码',
      enName: 'Reset Password'
    }
  }
  // 其他首页的路由配置
]

export default loginRoutes
